export const common = {
  // Navigation
  "nav.service": "Service",
  "nav.accessTiers": "Niveaux d'accès",
  "nav.philosophy": "Philosophie",
  "nav.requestAccess": "Demander l'accès",

  // Hero
  "hero.badge": "Sur invitation uniquement",
  "hero.title1": "Accès privé au",
  "hero.title2": "futur de la",
  "hero.title3": "robotique domestique",
  "hero.subtitle":
    "Un service de conciergerie exclusif pour ceux qui souhaitent un accès prioritaire, des conseils d'experts et une adoption fluide des robots domestiques de nouvelle génération—dès qu'ils seront disponibles.",
  "hero.cta1": "Demander un accès prioritaire",
  "hero.cta2": "Rejoindre la liste privée",

  // Social Proof
  "social.text":
    "Conçu pour un nombre limité de clients qui valorisent la discrétion, le temps et l'accès anticipé aux technologies transformatrices.",

  // Scarcity & Pain Points
  "scarcity.label": "La réalité du marché",
  "scarcity.title": "Sans accès prioritaire, vous risquez d'attendre des années",
  "scarcity.subtitle": "Les robots domestiques avancés ne seront pas disponibles pour tous. Voici pourquoi l'accès privilégié change tout.",
  "scarcity.pain1.title": "Listes d'attente interminables",
  "scarcity.pain1.desc": "Les premiers modèles grand public auront des listes d'attente de 18 à 36 mois. Sans priorité, vous serez derrière des milliers d'autres.",
  "scarcity.pain2.title": "Processus d'achat complexes",
  "scarcity.pain2.desc": "Systèmes de loterie, fenêtres de commande de quelques heures, procédures opaques. La plupart des gens manqueront leur chance.",
  "scarcity.pain3.title": "Information fragmentée",
  "scarcity.pain3.desc": "Les annonces de disponibilité se font sans préavis, sur des canaux dispersés. Vous apprendrez l'ouverture des commandes... après leur fermeture.",
  "scarcity.pain4.title": "Prix imprévisibles",
  "scarcity.pain4.desc": "Les premiers prix peuvent fluctuer de 40% selon le moment et le canal d'achat. Sans veille, vous paierez le prix fort.",
  "scarcity.solution": "Nos membres évitent ces obstacles. Ils sont alertés en premier, guidés à chaque étape, et positionnés en tête de file.",

  // How It Works
  "how.label": "Le processus",
  "how.title": "Accès prioritaire sans effort",
  "how.step1.title": "Rejoignez la liste prioritaire",
  "how.step1.desc":
    "Soumettez votre candidature pour une adhésion exclusive. Notre équipe examine chaque demande pour garantir l'adéquation avec nos standards de service.",
  "how.step2.title": "Recevez des mises à jour sélectionnées",
  "how.step2.desc":
    "Recevez des alertes anticipées sur les technologies émergentes, les lancements de produits et les fenêtres de disponibilité avant le grand public.",
  "how.step3.title": "Accès assisté dès la disponibilité",
  "how.step3.desc":
    "Naviguez dans les processus d'acquisition complexes avec l'aide d'experts, garantissant un accès prioritaire sans friction.",
  "how.step4.title": "Support haut de gamme",
  "how.step4.desc":
    "Installation, configuration et support technique continu en option pour une intégration parfaite dans votre foyer.",

  // Value Proposition
  "value.title": "Transparence de l'investissement",
  "value.subtitle":
    "Votre adhésion couvre des services exclusifs, pas la vente de produits.",
  "value.b1.title": "Accès prioritaire et alertes",
  "value.b1.desc":
    "Soyez le premier informé lorsque de nouvelles technologies deviennent disponibles",
  "value.b2.title": "Veille technologique indépendante",
  "value.b2.desc":
    "Suivi impartial du paysage émergent de la robotique domestique",
  "value.b3.title": "Processus d'acquisition assisté",
  "value.b3.desc":
    "Accompagnement expert dans les procédures d'achat complexes",
  "value.b4.title": "Support niveau conciergerie",
  "value.b4.desc":
    "Assistance dédiée adaptée à vos besoins spécifiques",
  "value.b5.title": "Installation et configuration en option",
  "value.b5.desc":
    "Services professionnels de mise en place et d'intégration disponibles",
  "value.disclaimer":
    "Ce service ne vend pas de robots et n'est affilié à aucun fabricant.",

  // Pricing
  "pricing.label": "Niveaux d'accès",
  "pricing.title": "Choisissez votre niveau de priorité",
  "pricing.elite": "Accès Élite",
  "pricing.premium": "Conciergerie Premium",
  "pricing.founders": "Cercle des Fondateurs",
  "pricing.limited": "Disponibilité limitée",
  "pricing.fee": "Frais de service uniques",
  "pricing.select": "Choisir ce niveau",
  "pricing.apply": "Postuler maintenant",
  "pricing.note":
    "Les frais s'appliquent aux services uniquement. Aucune vente de produits. Totalement transparent.",
  "pricing.e1": "Adhésion à la liste prioritaire",
  "pricing.e2": "Mises à jour technologiques trimestrielles",
  "pricing.e3": "Alertes produits anticipées",
  "pricing.e4": "Support par email",
  "pricing.e5": "Accès aux ressources membres",
  "pricing.e6": "Conseils d'acquisition",
  "pricing.e7": "Rapports d'intelligence marché",
  "pricing.e8": "Accès au forum communautaire",
  "pricing.p1": "Tous les avantages Accès Élite",
  "pricing.p2": "Briefings personnalisés mensuels",
  "pricing.p3": "Contact concierge dédié",
  "pricing.p4": "Support téléphonique prioritaire",
  "pricing.p5": "Processus d'acquisition assisté",
  "pricing.p6": "Coordination de l'installation",
  "pricing.p7": "Consultation technique (2 heures)",
  "pricing.p8": "Invitations à des événements exclusifs",
  "pricing.p9": "Période de support étendue",
  "pricing.f1": "Tous les avantages Conciergerie Premium",
  "pricing.f2": "Service d'installation haut de gamme",
  "pricing.f3": "Support technique illimité",
  "pricing.f4": "Conseiller technologique personnel",
  "pricing.f5": "Garantie de premier accès",
  "pricing.f6": "Planification d'intégration sur mesure",
  "pricing.f7": "Audit technologique annuel du domicile",
  "pricing.f8": "Accès VIP aux événements",
  "pricing.f9": "Statut prioritaire à vie",
  "pricing.f10": "Ligne concierge (24h/24, 7j/7)",

  // Philosophy
  "phil.label": "Notre philosophie",
  "phil.main":
    "À mesure que les robots domestiques avancés approchent de la disponibilité réelle, l'accès sera limité, complexe et sensible au temps. Ce service existe pour éliminer les frictions et garantir que nos clients soient toujours les premiers—sans stress.",
  "phil.p1":
    "Nous maintenons une indépendance totale vis-à-vis de tous les fabricants et marques. Notre seul engagement est envers nos clients—fournir des conseils impartiaux, des informations transparentes et un positionnement prioritaire sur un marché émergent.",
  "phil.p2":
    "Il ne s'agit pas de vendre des produits. Il s'agit de fournir l'expertise, l'accès et la tranquillité d'esprit qui accompagnent un concierge technologique dédié qui comprend à la fois les innovations et vos besoins uniques.",

  // Trust & Legal
  "trust.t1.title": "Service indépendant",
  "trust.t1.desc":
    "Aucune affiliation avec des fabricants ni partenariat de marque. Nos recommandations sont impartiales et centrées sur le client.",
  "trust.t2.title": "Aucune garantie produit",
  "trust.t2.desc":
    "Nous fournissons uniquement des services d'accès. La disponibilité et les spécifications des produits sont déterminées par les fabricants.",
  "trust.t3.title": "Tarification transparente",
  "trust.t3.desc":
    "Frais de service clairs et initiaux sans coûts cachés. Vous payez pour l'expertise et l'accès prioritaire, pas pour des produits.",
  "trust.t4.title": "Politique de remboursement équitable",
  "trust.t4.desc":
    "Satisfaction de service garantie. Consultez nos conditions pour les détails complets de la politique de remboursement.",

  // Final CTA
  "cta.title1": "Soyez prêt avant",
  "cta.title2": "le reste du monde",
  "cta.subtitle":
    "L'accès prioritaire est intentionnellement limité pour maintenir la qualité du service et l'exclusivité.",
  "cta.formTitle": "Candidature d'accès prioritaire",
  "cta.fullName": "Nom complet",
  "cta.email": "Adresse email",
  "cta.phone": "Numéro de téléphone",
  "cta.tier": "Niveau d'accès souhaité",
  "cta.message": "Parlez-nous de votre intérêt (Optionnel)",
  "cta.namePlaceholder": "Entrez votre nom complet",
  "cta.emailPlaceholder": "votre@email.com",
  "cta.phonePlaceholder": "+33 6 00 00 00 00",
  "cta.messagePlaceholder":
    "Qu'est-ce qui vous intéresse le plus ? Des exigences spécifiques ?",
  "cta.submit": "Postuler pour un accès prioritaire",
  "cta.submitting": "Envoi en cours...",
  "cta.success": "Candidature soumise avec succès ! Nous vous contacterons bientôt.",
  "cta.error": "Une erreur est survenue. Veuillez réessayer.",
  "cta.limited": "Les places sont intentionnellement limitées.",
  "cta.chars": "caractères",

  // Footer
  "footer.tagline":
    "Accès prioritaire exclusif à la robotique domestique de nouvelle génération",
  "footer.legal": "Mentions légales",
  "footer.legalNotice": "Mentions légales",
  "footer.terms": "Conditions d\\'utilisation",
  "footer.privacy": "Politique de confidentialité",
  "footer.agreement": "Contrat de service",
  "footer.contact": "Contact",
  "footer.contactConcierge": "Contacter le concierge",
  "footer.copyright":
    "\u00a9 2026 NOKX GLOBAL LTD. Tous droits réservés.",

  // Language
  "lang.en": "English",
  "lang.fr": "Français",

  // Legal Notice Page
  "legal.backHome": "Retour à l\\'accueil",
  "legal.label": "Informations légales",
  "legal.title": "Mentions Légales",
  "legal.lastUpdated": "Dernière mise à jour",
  "legal.allRightsReserved": "Tous droits réservés.",
  "legal.companyInfo": "Informations sur la société",
  "legal.companyName": "Raison sociale",
  "legal.companyNumber": "Numéro d\\'immatriculation",
  "legal.companyType": "Type de société",
  "legal.privateLimited": "Société privée à responsabilité limitée",
  "legal.incorporatedOn": "Date d\\'immatriculation",
  "legal.registeredAddress": "Siège social",
  "legal.companyStatus": "Statut de la société",
  "legal.active": "Active",
  "legal.businessActivity": "Activité (SIC)",
  "legal.sicDescription": "Vente au détail par correspondance ou via Internet",
  "legal.servicesTitle": "Nature des services",
  "legal.servicesP1": "NOKX GLOBAL LTD exploite un service de conciergerie technologique privé offrant un accès prioritaire, des conseils d\\'experts et des services d\\'acquisition assistée pour la robotique domestique de nouvelle génération et les technologies domotiques.",
  "legal.servicesP2": "Notre service comprend des niveaux d\\'accès par adhésion offrant une veille technologique, des briefings personnalisés, une assistance à l\\'acquisition, une coordination de l\\'installation et un support technique continu.",
  "legal.servicesDisclaimer": "Important : Ce service ne vend, ne fabrique ni ne distribue de robots ou de produits physiques. Nous sommes un service de conciergerie indépendant sans affiliation avec aucun fabricant. Tous les frais concernent exclusivement nos services de conseil et d\\'accès.",
  "legal.ipTitle": "Propriété intellectuelle",
  "legal.ipP1": "Tout le contenu de ce site web, y compris mais sans s\\'y limiter les textes, graphiques, logos, images et logiciels, est la propriété de NOKX GLOBAL LTD et est protégé par les lois britanniques et internationales sur le droit d\\'auteur.",
  "legal.ipP2": "Aucune partie de ce site web ne peut être reproduite, distribuée ou transmise sous quelque forme que ce soit sans l\\'autorisation écrite préalable de NOKX GLOBAL LTD.",
  "legal.liabilityTitle": "Limitation de responsabilité",
  "legal.liabilityP1": "Les informations fournies sur ce site web sont à titre informatif uniquement. Bien que nous nous efforcions de maintenir les informations exactes et à jour, NOKX GLOBAL LTD ne fait aucune déclaration ni garantie quant à l\\'exhaustivité, l\\'exactitude ou la fiabilité des informations.",
  "legal.liabilityP2": "NOKX GLOBAL LTD ne saurait être tenue responsable de tout dommage indirect, accessoire, spécial, consécutif ou punitif découlant de votre utilisation de nos services ou de ce site web.",
  "legal.liabilityP3": "La disponibilité des produits, les spécifications, les prix et les dates de sortie mentionnés sur ce site sont susceptibles d\\'être modifiés par leurs fabricants respectifs et sont fournis à titre informatif uniquement.",
  "legal.privacyTitle": "Protection des données et confidentialité",
  "legal.privacyP1": "NOKX GLOBAL LTD s\\'engage à protéger vos données personnelles conformément au Règlement général sur la protection des données du Royaume-Uni (UK GDPR) et à la loi sur la protection des données de 2018. Nous collectons et traitons les données personnelles uniquement dans la mesure nécessaire à la fourniture de nos services.",
  "legal.privacyL1": "Nous collectons les informations personnelles que vous fournissez volontairement, telles que votre nom, adresse e-mail, numéro de téléphone et préférences de service.",
  "legal.privacyL2": "Vos données sont utilisées uniquement pour traiter votre demande d\\'adhésion, fournir nos services de conciergerie et communiquer les mises à jour pertinentes.",
  "legal.privacyL3": "Nous ne vendons, ne louons ni ne partageons vos informations personnelles avec des tiers à des fins marketing.",
  "legal.privacyL4": "Vous avez le droit d\\'accéder, de rectifier, d\\'effacer ou de restreindre le traitement de vos données personnelles à tout moment en nous contactant.",
  "legal.privacyP2": "Le traitement des paiements est géré de manière sécurisée par Stripe, un processeur de paiement conforme PCI-DSS. Nous ne stockons pas les détails de votre carte de paiement sur nos serveurs.",
  "legal.paymentTitle": "Conditions de paiement",
  "legal.paymentP1": "Tous les frais de service sont des paiements uniques en euros (\u20ac) et sont clairement affichés avant l\\'achat. Les paiements sont traités de manière sécurisée via Stripe. En effectuant un achat, vous acceptez les conditions du niveau de service applicable.",
  "legal.paymentP2": "Les prix incluent toutes les taxes applicables sauf indication contraire. NOKX GLOBAL LTD se réserve le droit de modifier les tarifs pour les futures adhésions avec un préavis raisonnable.",
  "legal.refundTitle": "Politique de remboursement",
  "legal.refundP1": "Si vous n\\'êtes pas satisfait de notre service, vous pouvez demander un remboursement dans les 14 jours suivant votre achat, à condition qu\\'aucun service substantiel n\\'ait été fourni. Les demandes de remboursement doivent être envoyées à notre adresse e-mail de contact.",
  "legal.refundP2": "Après la période de 14 jours, ou une fois que la prestation de service substantielle a commencé, les remboursements seront évalués au cas par cas à la discrétion de NOKX GLOBAL LTD.",
  "legal.governingTitle": "Droit applicable",
  "legal.governingP1": "Ces conditions et toutes les questions découlant de ou liées à l\\'utilisation de ce site web et de nos services seront régies et interprétées conformément aux lois d\\'Angleterre et du Pays de Galles. Tout litige sera soumis à la compétence exclusive des tribunaux d\\'Angleterre et du Pays de Galles.",
  "legal.contactTitle": "Nous contacter"
};
